import { render, staticRenderFns } from "./monstrans.vue?vue&type=template&id=27ef8ef1&scoped=true&"
import script from "./monstrans.vue?vue&type=script&lang=js&"
export * from "./monstrans.vue?vue&type=script&lang=js&"
import style0 from "./monstrans.vue?vue&type=style&index=0&id=27ef8ef1&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27ef8ef1",
  null
  
)

export default component.exports